import { MatchHistory } from "types/web-app";
import { StandardFrame } from "../ui/frames/standard-frame";
import React from "react";

interface DuelHistoryCardProps {
  match: MatchHistory;
}

export const DuelHistoryCard: React.FC<DuelHistoryCardProps> = ({ match }) => {
  const isWin = match.result === "win";
  const isDraw = match.result === "draw";

  const date = new Date(match.timestamp).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <StandardFrame
      variant={isWin ? "green" : "red"}
      className="w-full"
    >
      <div className="flex flex-col gap-2 p-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className={`font-bold text-sm uppercase px-2 py-0.5 rounded ${
              isWin
                ? "bg-pk-blue-4 text-white"
                : isDraw
                  ? "bg-pk-gray-4 text-white"
                  : "bg-pk-red-4 text-white"
            }`}
          >
            {match.result}
          </span>
          <span className="text-pk-gray-4 text-xs font-bold">
            vs {match.opponent_name}
          </span>
          {match.is_bot_match && (
            <span className="text-pk-gray-3 text-xs">(Bot)</span>
          )}
        </div>
        <span className="text-pk-gray-5 text-xs font-bold">{date}</span>
      </div>
      </div>
    </StandardFrame>
  );
};
